import QuantitySelector from '../inputs/quantity-selector';
import AsyncProductData from './async-product-data';

export default class ProductQuantitySelector extends QuantitySelector {

  static readonly QUANTITY_SELECTOR_SELECTOR = '.js-updateProductAvailability';
  static readonly QUANTITY_INPUT_SELECTOR = '.js-qty-selector-input';
  private timeout;
  private readonly timeoutLength: number = 2000;
  protected readonly input: JQuery;
  private productCode = '';

  constructor(container: JQuery) {
    super(container);
    this.input = this.container.find(ProductQuantitySelector.QUANTITY_INPUT_SELECTOR);
    this.productCode = this.input[0].dataset.productCode || '';
    this.bindChange();
  }

  static initAll(): void {
    $(ProductQuantitySelector.QUANTITY_SELECTOR_SELECTOR).map((i, el) => new ProductQuantitySelector($(el)));
  }

  bindChange(): void {
    this.input.on('change', () => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => this.submitChangedQuantity(), this.timeoutLength);
    });
  }

  submitChangedQuantity(): void {
    const quantity = this.input.val() as string;
    void AsyncProductData.refetchNewDataAndCalculations(this.productCode, quantity);
  }
}
